import { PREPROD_PREVIEW_EVENTS, PREPROD_PREVIEW_ACTIONS } from './types';
export var initiatePreproductBoardEvent = function initiatePreproductBoardEvent(iframeRef, markAsVisited) {
  var _iframeRef$current;

  if (iframeRef !== null && iframeRef !== void 0 && (_iframeRef$current = iframeRef.current) !== null && _iframeRef$current !== void 0 && _iframeRef$current.contentWindow) {
    iframeRef.current.contentWindow.postMessage({
      type: PREPROD_PREVIEW_EVENTS.LITE_CREATE_BOARD,
      visited: markAsVisited
    }, '*');
  }
};
export var fitContentEvent = function fitContentEvent(iframeRef) {
  var _iframeRef$current2;

  if (iframeRef !== null && iframeRef !== void 0 && (_iframeRef$current2 = iframeRef.current) !== null && _iframeRef$current2 !== void 0 && _iframeRef$current2.contentWindow) {
    iframeRef.current.contentWindow.postMessage({
      type: PREPROD_PREVIEW_EVENTS.LITE_FIT_CONTENT
    }, '*');
  }
};
export var fullscreenStatusEvent = function fullscreenStatusEvent(iframeRef, isFullscreen) {
  var _iframeRef$current3;

  if (iframeRef !== null && iframeRef !== void 0 && (_iframeRef$current3 = iframeRef.current) !== null && _iframeRef$current3 !== void 0 && _iframeRef$current3.contentWindow) {
    iframeRef.current.contentWindow.postMessage({
      type: PREPROD_PREVIEW_EVENTS.LITE_FULLSCREEN_STATUS,
      payload: isFullscreen
    }, '*');
  }
};
export var initiatePreproductBoardAction = function initiatePreproductBoardAction(dispatch) {
  dispatch({
    type: PREPROD_PREVIEW_ACTIONS.SET_IS_IFRAME_VISIBLE,
    payload: true
  });
  dispatch({
    type: PREPROD_PREVIEW_ACTIONS.SET_BOARD_CONTAINER_DISPLAY_MODE,
    payload: 'modal'
  });
};